/**
 * @ngdoc Controller
 * @name RecurringReportsController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('ReportTemplatesController', ReportTemplatesController);

    /**
     * @constructor
     * @ngInject
     */
    function ReportTemplatesController(
        $q,
        $log,
        $scope,
        $state,
        ApiService,
        VrmModalService,
        vrmNotificationsService,
        vrmNotificationType,
        InstallationsService,
        $stateParams,
        moment,
        locale
    ) {
        $log.info('ReportTemplatesController');

        $scope.loading = true;
        $scope.mobileView = window.innerWidth < 750;
        angular.element(window).on('resize', _.debounce(function() {
            $scope.mobileView = window.innerWidth < 750;
            $scope.$digest();
        }, 250));

        $scope.hasReportTemplates = false;
        $scope.reportTemplates = [];
        $scope.$watch('reportTemplates', function() {
            $scope.hasReportTemplates = $scope.reportTemplates.length > 0;
        });

        const redirectUnauthorizedUser = () => {
            InstallationsService.getInstallation($stateParams.id).then(function (installation) {
                if (!installation.view_permissions.update_settings) {
                    InstallationsService.redirectUnauthorizedUser(installation);
                }
            });
        }

        redirectUnauthorizedUser();

        ApiService.reportTemplates($stateParams.id,null,null,'GET').then(function(response) {
            $scope.reportTemplates = response.data.reportTemplates;
            $scope.loading = false;
        }).catch(function (response) {
            // Non-full-access user shouldn't be able to access this page
            if (response.status === 403) {
                redirectUnauthorizedUser();
            }
        });

        $scope.deleteTemplate = function (template) {
            VrmModalService.openDeleteModal($scope, 'report_template', template.name, function (confirmed) {
                if (confirmed) {
                    ApiService.reportTemplates($stateParams.id, template.idReportTemplate, null, 'DELETE').then(function (res) {
                        if (res.data && res.data.success) {
                            $scope.reportTemplates = $scope.reportTemplates.filter(function (r) {
                                return (r.idReportTemplate !== template.idReportTemplate);
                            });
                            locale.ready('reporting').then(function () {
                                vrmNotificationsService.add({ type: vrmNotificationType.SUCCESS, message: locale.getString('reporting.report_template_deleted') });
                            });
                        }
                    });
                }
            });
        };
    }

})();
